import type { FluxErrorEntityErrorCodes } from '../types.js';

export const BulkActionsErrorCodes = {
  BulkActionAlreadyDispatched: {
    code: 'bulk-action/already-dispatched',
    explanation:
      'Esta ação em massa já foi enviada para processamento e não pode ser reenviada. Ações em massa só podem ser processadas uma vez.',
    localizations: {},
    message: 'Esta ação em massa já foi enviada para processamento.',
  },
  BulkActionDownloadFailed: {
    code: 'bulk-action/download-failed',
    explanation:
      'Não foi possível executar a ação em massa pois o arquivo informado não pôde ser baixado. Isso pode ocorrer por diversos motivos, como problemas internos ou o arquivo não estar mais disponível.',
    localizations: {},
    message: 'Não foi possível baixar o arquivo informado para executar a ação em massa.',
  },
  BulkActionInvalidActionType: {
    code: 'bulk-action/invalid-action-type',
    explanation:
      'O tipo de ação em massa fornecido é inválido. Verifique se o tipo está correto e tente novamente.',
    localizations: {},
    message: 'O tipo de ação em massa informado é inválido.',
  },
  BulkActionInvalidInput: {
    code: 'bulk-action/invalid-input',
    explanation:
      'Os dados fornecidos para a ação em massa são inválidos. Verifique se a configuração da entidade está correta e tente novamente.',
    localizations: {},
    message: 'Os dados fornecidos para a ação em massa são inválidos.',
  },
  BulkActionMissingEntityId: {
    code: 'bulk-action/missing-entity-id',
    explanation:
      'O ID da entidade necessária para executar a ação em massa está faltando. Cada tipo de ação requer um ID de uma entidade específica.',
    localizations: {},
    message: 'O ID da entidade necessária para executar a ação em massa está faltando.',
  },
  BulkActionMissingInputFile: {
    code: 'bulk-action/missing-input-file',
    explanation:
      'O arquivo de entrada necessário para executar a ação em massa está faltando. Verifique se o arquivo foi fornecido corretamente.',
    localizations: {},
    message: 'O arquivo de entrada necessário para executar a ação em massa está faltando.',
  },
  BulkActionNotCreator: {
    code: 'bulk-action/not-creator',
    explanation:
      'Apenas o criador da ação em massa pode interagir com a ação. Caso necessário, crie uma nova ação em massa.',
    localizations: {},
    message: 'Apenas o criador da ação em massa pode interagir.',
  },
  BulkActionNotFound: {
    code: 'bulk-action/not-found',
    explanation: 'A ação em massa que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'Ação em massa não encontrada.',
  },
  BulkActionUnsupportedFileType: {
    code: 'bulk-action/unsupported-file-type',
    explanation:
      'O tipo de arquivo fornecido para a ação em massa não é suportado. A ação em massa suporta aquivos nos formatos CSV, XLSX e JSON.',
    localizations: {},
    message: 'O tipo de arquivo fornecido não é suportado para esta ação em massa.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'bulk-action'>;
